
import { useParams, useLocation } from "react-router-dom";
import useBillInvoice from "./hooks/useBillInvoice";
import { useEffect, useMemo, useRef, useCallback } from "react";
import html2pdf from "html2pdf.js";
import InvoicePDF from "../../Components/PDF/invoice";

const GstPreviewInvoice = () => {
  const { data, method } = useBillInvoice();
  const { previewInvoiceList, qrCodeData } = data;

  const { refNumber } = useParams();
  const { gstPreviewInvoice } = method;

  const componentRef = useRef(null);

  // read query param
  const location = useLocation();
  const shouldAutoDownload = new URLSearchParams(location.search).get("download") === "1";

  // prevent multiple downloads
  const hasDownloadedRef = useRef(false);

  useEffect(() => {
    if (refNumber) gstPreviewInvoice(refNumber);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refNumber]);

  const computed = useMemo(() => {
    const rows = (previewInvoiceList?.services || []).map((s, idx) => {
      const basePrice = Number(s?.basePrice ?? 0) || 0;
      const gstPercent = Number(s?.gstValue ?? 0) || 0;
      const gstAmount = Number(s?.gstPrice ?? 0) || 0;
      const total = Number(s?.finalAmount ?? basePrice + gstAmount) || 0;

      return {
        id: s?.serviceId || s?._id || `${idx}`,
        idx: idx + 1,
        name: s?.serviceName || "-",
        staff: s?.staffName || "-",
        gstStatus: s?.GST || "EXCLUDE",
        basePrice,
        gstPercent,
        gstAmount,
        total,
      };
    });

    return {
      rows,
      subtotalExcl: Number(previewInvoiceList?.subTotal ?? 0) || 0,
      totalGst: Number(previewInvoiceList?.totalGst ?? 0) || 0,
      totalAmount: Number(previewInvoiceList?.totalAmount ?? 0) || 0,
    };
  }, [previewInvoiceList]);

  const outerCard = useMemo(
    () => ({
      background: "#fff",
      borderRadius: 10,
      boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
      overflow: "hidden",
      maxWidth: 1200,
      margin: "0 auto",
    }),
    []
  );

  const innerPad = useMemo(() => ({ padding: 32 }), []);
  const orange = "#ff6a00";

  const handlePrint = useCallback(() => {
    const element = componentRef.current;
    if (!element) return;

    element.scrollTop = 0;

    // html2pdf()
    //   .set({
    //     margin: 3,
    //     filename: `patientBill-${previewInvoiceList?.refNumber || refNumber || "invoice"}.pdf`,
    //     image: { type: "jpeg", quality: 1 },
    //     html2canvas: {
    //       scale: 2,
    //       useCORS: true,
    //       logging: false,
    //       windowWidth: 794,
    //       windowHeight: 1123,
    //       backgroundColor: "#ffffff",
    //     },
    //     jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    //     pagebreak: { mode: ["css", "legacy"], avoid: ["table", ".note", ".footer-row"] },
    //   })
    html2pdf().set({
  margin: 10,
  filename: `patientBill-${previewInvoiceList?.refNumber}.pdf`,
  image: { type: "jpeg", quality: 1 },
  html2canvas: {
    scale: 2,
    useCORS: true,
    backgroundColor: "#ffffff",
  },
  jsPDF: {
    unit: "mm",
    format: "a4",
    orientation: "portrait",
  },
  pagebreak: {
    mode: ["css"],
    avoid: [".section-two", ".iskedo-page"]
  }
})
      .from(element)
      .save();
  }, [previewInvoiceList?.refNumber, refNumber]);

  // auto-download once data is ready
  useEffect(() => {
    if (!shouldAutoDownload) return;
    if (!previewInvoiceList?._id && !previewInvoiceList?.refNumber) return;
    if (hasDownloadedRef.current) return;

    hasDownloadedRef.current = true;

    // wait one paint so DOM is ready for html2pdf
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        handlePrint();
      });
    });
  }, [shouldAutoDownload, previewInvoiceList?._id, previewInvoiceList?.refNumber, handlePrint]);

  if (!previewInvoiceList) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
        <div>Loading invoice...</div>
      </div>
    );
  }

  return (
    <div style={{ background: "#f5f5f5", minHeight: "100vh", padding: "40px 20px" }}>
      {/* Top bar */}
      <div style={{ maxWidth: 1200, margin: "0 auto 16px", display: "flex", justifyContent: "flex-end", gap: 12 }}>
        <button
          onClick={handlePrint}
          style={{
            padding: "10px 14px",
            borderRadius: 8,
            border: "1px solid #ddd",
            background: "#fff",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Download PDF
        </button>
      </div>

      <InvoicePDF
        previewInvoiceList={previewInvoiceList}
        computed={computed}
        componentRef={componentRef}
        outerCard={outerCard}
        innerPad={innerPad}
        orange={orange}
        qrCodeData={qrCodeData}
      />
    </div>
  );
};

export default GstPreviewInvoice;

